import React from "react";

import { DownloadLink } from "@sia/style-guide";

function HomePageParticipateLink({ translate, surveyIsActive, onRevisionPhase, isSurveyFinished, surveyUrl }) {
  let link = null;

  if (isSurveyFinished) {
    return link;
  }

  if (surveyIsActive) {
    link = (
      <DownloadLink
        openInCurrentTab
        icon="INTERNAL"
        variant="INTERNAL"
        href={surveyUrl}
        text={translate("benchmarking.landing-page.logged-in.participate.text")}
      ></DownloadLink>
    );
    return link;
  }

  if (onRevisionPhase) {
    link = (
      <DownloadLink
        openInCurrentTab
        icon="INTERNAL"
        variant="INTERNAL"
        href={surveyUrl}
        text={translate("benchmarking.landing-page.logged-in.closed-survey.revise.input")}
      ></DownloadLink>
    );
    return link;
  }

  return link;
}

export default HomePageParticipateLink;
